import { render, staticRenderFns } from "./projectCount.vue?vue&type=template&id=a9513d24&scoped=true"
import script from "./projectCount.vue?vue&type=script&lang=js"
export * from "./projectCount.vue?vue&type=script&lang=js"
import style0 from "./projectCount.vue?vue&type=style&index=0&id=a9513d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9513d24",
  null
  
)

export default component.exports